var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuseum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "museum 1",
    clipPath: "url(#clip0_6801_2966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.95312 16.6406H5.625V32.5781H1.95312V16.6406Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.96875 16.6406H11.9531V32.5781H7.96875V16.6406Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.0469 16.6406H32.0312V32.5781H28.0469V16.6406Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M14.2969 16.6406H25.7031V32.5781H14.2969V16.6406Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.078125 36.0938V38.8281C0.078125 39.4753 0.602812 40 1.25 40H38.75C39.3972 40 39.9219 39.4753 39.9219 38.8281V36.0938C39.9219 35.4466 39.3972 34.9219 38.75 34.9219H1.25C0.602812 34.9219 0.078125 35.4466 0.078125 36.0938Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.24998 14.2969H38.75C39.2708 14.2969 39.7292 13.9531 39.875 13.4531C40.0208 12.9531 39.8191 12.4169 39.38 12.1369L20.63 0.183752C20.2457 -0.0611694 19.7544 -0.0611694 19.3701 0.183752L0.620059 12.1369C0.18084 12.4168 -0.0208784 12.953 0.124981 13.4531C0.270762 13.9531 0.729122 14.2969 1.24998 14.2969ZM18.8336 7.38438C18.9036 6.70969 19.5252 6.21875 20.2289 6.35078C20.8657 6.48328 21.27 7.08383 21.1492 7.72891C21.0171 8.36235 20.4198 8.77063 19.7711 8.64922C19.1933 8.52875 18.782 8.01492 18.8336 7.38438Z",
    fill: "#7FD7A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.375 16.6406H38.0469V32.5781H34.375V16.6406Z",
    fill: "#7FD7A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6801_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.467b2a2523233294ddf2e6963512c865.svg";
export { ForwardRef as ReactComponent };